import React from 'react';
import { ToggleMetricsContext, ToggleMetricsContextType } from 'src/providers';

export const useToggleMetricsContext = (): ToggleMetricsContextType =>
  React.useContext<ToggleMetricsContextType>(ToggleMetricsContext);
